import { render, staticRenderFns } from "./GmbReviews.vue?vue&type=template&id=6319cc5f&scoped=true"
import script from "./GmbReviews.vue?vue&type=script&lang=js"
export * from "./GmbReviews.vue?vue&type=script&lang=js"
import style0 from "./GmbReviews.vue?vue&type=style&index=0&id=6319cc5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319cc5f",
  null
  
)

export default component.exports